import { supabase } from "../libs/supabase";
import type { User, Session, AuthChangeEvent } from "@supabase/supabase-js";
import { saveGoogleUser } from "./userService";

export const authService = {
	async signUp(email: string, password: string, username: string) {
		const { data, error } = await supabase.auth.signUp({
			email,
			password,
			options: {
				data: {
					username,
				},
			},
		});
		if (error) throw error;
		return data;
	},

	async login(email: string, password: string) {
		const { data, error } = await supabase.auth.signInWithPassword({
			email,
			password,
		});
		if (error) throw error;
		return data;
	},

	async loginWithGoogle(): Promise<User> {
		const { error } = await supabase.auth.signInWithOAuth({
			provider: "google",
			options: {
				redirectTo: `${window.location.origin}/auth/callback`,
			},
		});
		if (error) throw error;

		return new Promise<User>((resolve, reject) => {
			const {
				data: { subscription },
			} = supabase.auth.onAuthStateChange(
				async (event: AuthChangeEvent, session: Session | null) => {
					if (event === "SIGNED_IN" && session?.user) {
						subscription.unsubscribe();
						console.log("Google認証成功:", session.user);
						try {
							// Google認証後にユーザー情報を保存
							const savedUser = await saveGoogleUser(session.user);
							if (savedUser) {
								console.log("ユーザー情報保存成功:", savedUser);
								resolve(session.user);
							} else {
								console.error("ユーザー情報の保存に失敗しました。");
								reject(new Error("ユーザー情報の保存に失敗しました。"));
							}
						} catch (error) {
							console.error("ユーザー情報保存エラー:", error);
							reject(error);
						}
					}
				},
			);

			// 5分後にタイムアウト
			setTimeout(() => {
				subscription.unsubscribe();
				reject(new Error("Google認証がタイムアウトしました。"));
			}, 300000); // 5分 = 300000ミリ秒
		});
	},

	async logout() {
		const { error } = await supabase.auth.signOut();
		if (error) throw error;
	},

	async resetPassword(email: string) {
		const { data, error } = await supabase.auth.resetPasswordForEmail(email);
		if (error) throw error;
		return data;
	},
};
